// Intialise app push notifications if right page
$( document ).on("turbo:load", initNotifications);

// Main logic
function initNotifications() {

  if($(".app-new-push-notification").length) {
    var appLatLng = {
      latitude: parseFloat($('.targets-form-group').data('lat')),
      longitude: parseFloat($('.targets-form-group').data('lon'))
    },
    appRadius;

    // Hide all dependent fields
    function hideDependentFields() {
      $(".action-form-group").hide();
      $(".node-content-id-form-group").hide();
      $(".app-store-id-form-group").hide();
      $(".play-store-id-form-group").hide();
      $(".targets-form-group").hide();
    }

    // Hide or show app store and play store field groups
    function setStoreFields(display) {
      if(display === false) {
        $(".app-store-id-form-group").hide();
        $(".play-store-id-form-group").hide();
      } else {
        $(".app-store-id-form-group").show();
        $(".play-store-id-form-group").show();
      }
    }

    // Initialise Google Maps
    function initMap() {
      $('#map').locationpicker({
        location: {
          latitude: appLatLng.latitude,
          longitude: appLatLng.longitude
        },
        radius: parseInt($(".modal-radius").val()) || 1000,
        zoom: 10,
        inputBinding: {
          latitudeInput: $('.modal-latitude'),
          longitudeInput: $('.modal-longitude'),
          radiusInput: $('.modal-radius'),
          locationNameInput: $('.modal-search')
        },
        enableAutocomplete: true,
        onchanged: function(currentLocation, radius, isMarkerDropped) {
          if (radius == appRadius) {
              $(".modal-location").val('')
          }
        }
      });
    }

    hideDependentFields();

    // If a GPS point is selected, show it on the map
    $("#new_push_notification").on("change", "#target_location_id", function(ev) {
      var gpsId = $("#target_location_id :checked").val();

      if(gpsId.length) {
        $.getJSON("/admin/push_notifications/gps_point/" + gpsId + ".json", function(json) {
          myLatLng = { latitude: parseFloat(json.lat), longitude: parseFloat(json.lon) };
        }).done(function() {
          $('#map').locationpicker("location", myLatLng)
        })
      } else {
        $('#map').locationpicker("location", appLatLng)
      }
    });

    // Clear and populate node list on variant change
    $("#new_push_notification").on("change", "#push_notification_variant_id", function(ev) {
      var appId = $("#push_notification_app_id").val();
      var variantId = $("#push_notification_variant_id option:selected").val();

      if(variantId && variantId.length > 0) {
        $("#map-modal").on('shown.bs.modal', function () {
          var lat = parseFloat($(".latitude").val()),
              lot = parseFloat($(".longitude").val()),
              radius = parseInt($(".radius").val());
          if (lat && lot && radius) {
            $('#map').locationpicker("location", { latitude: lat, longitude: lot, radius: radius });
          }
          $('#map').locationpicker("autosize");
        });

        $("#location-save").on('click', function () {
          $(".latitude").val($(".modal-latitude").val());
          $(".longitude").val($(".modal-longitude").val());
          $(".radius").val($(".modal-radius").val());
        });

        $(".modal-latitude, .modal-longitude, .modal-search, .latitude, .longitude").on('change', function() {
          appRadius = $(".modal-radius").val()
        });

        $(" .latitude, .longitude").on('change', function() {
          $(".modal-location").val('')
        });

        initMap();

        $.get("/admin/apps/" + appId + "/notifications/nodes/" + variantId, function(data) {
          $("#push_notification_node_content_id").empty();
          $("#push_notification_node_content_id").append('<option value="">Select a node or content item...</option>');
          $("#push_notification_node_content_id").append(data);
        });
        $.get("/admin/apps/" + appId + "/notifications/gps_points/" + variantId + "/false", function(json) {
          $("#target_location_id").empty();
          $("#target_location_id").append('<option value="">Please select</option>');
          $.each(json.gps_points, function(key, value) {
            $("#target_location_id").append('<option value="' + value.id + '">' + value.name + '</option>');
          });
        });
        $(".action-form-group").show();
        $(".targets-form-group").show();
      } else {
        setStoreFields(false);
        $(".action-form-group").hide();
        $(".targets-form-group").hide();
        $(".node-content-id-form-group").hide();
      }
      $("#push_notification_node_content_id").val("");
      $("#push_notification_node_content_id").trigger("change");
      $("#push_notification_action").val("");
      $("#push_notification_action").trigger("change");
    });

    // Show / hide fields based on action chosen
    $("#new_push_notification").on("change", "#push_notification_action", function(ev) {
      $("#push_notification_node_content_id").val("");
      $("#push_notification_node_content_id").trigger("change");
      switch($("#push_notification_action").val()) {
        case "show_node_content":
          $(".node-content-id-form-group").show();
          setStoreFields(false);
          break;
        case "promote_apps":
          setStoreFields(true);
          $(".node-content-id-form-group").hide();
          break;
        case "simple_message":
          setStoreFields(false);
          $(".node-content-id-form-group").hide();
          break;
        case "show_app_variant_list":
          setStoreFields(false);
          $(".node-content-id-form-group").hide();
          break;
        default:
          $(".node-content-id-form-group").hide();
          setStoreFields(false);
      }
    });
  }
}
